import React from 'react';
import OuvrirFenetrePartenaireSansImg from '../../components/OuvrirFenetrePartenaireSansImg';
import OuvrirFenetrePartenaire from '../../components/OuvrirFenetrePartenaire';

const SetsContent = () => {
    return (
        <div className="category-content">
            <h3 className="content-title">Sets de table</h3>
            <div className="partner-section">
                <OuvrirFenetrePartenaireSansImg
                    sitePartenaire="https://www.esat-apf-jeanmuriel.fr/"
                    texteBoutonPartenaire="Set de table recto/verso créé en collaboration avec l'Esat Jean Muriel de Lunay"
                />
                <OuvrirFenetrePartenaire 
                    imageUrl="/ImgPartenaires/SetEsat.jpg" 
                    sitePartenaire="https://www.esat-apf-jeanmuriel.fr/"
                    classPartenaire='product-image'
                    altPartenaire='Esat Lunay'
                />
            </div>
        </div>
    );
};

export default SetsContent;
